import React from 'react';

/* можно 1 заменить на 2
  onChange={addAmount} //1
  onChange={(e) => addAmount(e)} //2
 */

export default function Operation({addTransaction, addDescription, addAmount, description, amount, doBackupOrRestore}){
  return (
    <>
    <section className="operation">
      <h3>Новая операция</h3>
      <form id="form">
        <label>
          <input
            type="text"
            className="operation__fields operation__name"
            placeholder="Наименование операции"
            onChange={addDescription}
            value={description}
          />
        </label>
        <label>
          <input
            type="number"
            className="operation__fields operation__amount"
            placeholder="Введите сумму"
            onChange={addAmount}
            value={amount}
          />
        </label>
        <div className="operation__btns">
          <button
            onClick={() => addTransaction(false)}
            type="button"
            className="operation__btn operation__btn-subtract"
          >РАСХОД</button>

          <button 
            onClick={() => addTransaction(true)}
            type="button" 
            className="operation__btn operation__btn-add"
          >ДОХОД</button>

        </div>

      </form>
    </section>

    <section className="operation operation_bu">
      <h3>Storage</h3>
      <div className="operation__btns">
        <button 
           onClick={() => doBackupOrRestore(true)}
           type="button" 
           className="operation__bu_btn operation__bu_btn-backup">Backup</button>
        <button 
           onClick={() => doBackupOrRestore(false)}
           type="button" 
           className="operation__bu_btn operation__bu_btn-restore">Restore</button>
        </div>
    </section>
    </>
  );
}

//export default Operation;  //for functions also for function-in-a-variable.